<template>
  <div>
    <form ref="fileform" @click="selectImage">
        <span class="drop-files">
          <slot></slot>
        </span>
    </form>
  </div>
</template>

<script>
import Vue from "vue";
import firebase from "firebase";

export default {
  name: "modal",
  props: ["image"],
  components: {
      
  },
  watch: {
    file: function(file) {
      console.log("watch file", file);
      var reader = new FileReader();
      reader.onload = () => {
        console.log("loaded");
        var arrayBuffer = reader.result;
        var bytes = arrayBuffer; //new Uint8Array(arrayBuffer);
        console.log("imageUpload", bytes);
        this.$emit("file-array", {bytes});
      }
      reader.readAsArrayBuffer(file);
    }
  },
  data: function() {
    return {
        files: [],
        fileSelector: null,
        file: null
    };
  },
  mounted: function() {
    var input = document.createElement('input');
    input.type = 'file';
    this.fileSelector = input;
    this.fileSelector.onchange = e => { 
      console.log(e);
      this.file = e.target.files[0];
    }
    ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach( function( evt ) {
      /*
        For each event add an event listener that prevents the default action
        (opening the file in the browser) and stop the propagation of the event (so
        no other elements open the file in the browser)
      */
      this.$refs.fileform.addEventListener(evt, function(e){
        e.preventDefault();
        e.stopPropagation();
      }.bind(this), false);
    }.bind(this));

    this.$refs.fileform.addEventListener('drop', function(e){
      /*
        Capture the files from the drop event and add them to our local files
        array.
      */
     this.file = e.dataTransfer.files[0];
    }.bind(this));
  },
  methods: {
      selectImage: function() {
        this.fileSelector.click();
      }
    }
};
</script>

<style scoped>
  form{
    cursor: pointer;
    display: block;
    height: 400px;
    width: 400px;
    background: #ccc;
    margin: auto;
    margin-top: 40px;
    text-align: center;
    line-height: 400px;
    border-radius: 4px;
        box-shadow: #dadada 0px 0px 4px;
  }
  .drop-files {
    color: #656565;
    font-weight: bold;
  }
</style>


// WEBPACK FOOTER //
// imageUpload.vue?50fdc6ac